import { useDeviceType } from '@cian/ui-kit';
import { MobileContainer } from './MobileContainer';
import { DesktopContainer } from './DesktopContainer';

export function TabsContainer() {
  const deviceType = useDeviceType();

  return deviceType === 'phone' ? <MobileContainer /> : <DesktopContainer />;
}
